// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-card__title[data-v-bf54d16a]{padding:10px 10px 0 10px;font-size:16px;font-weight:700}", ""]);
// Exports
module.exports = exports;
